import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import BootstrapColorService from "../../../Services/Shared/BootstrapColor.service";
const DEFAULT_HEIGHT = 10;
const Bar = (props) => {
    const sharedProps = {
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": props.progress * 100,
        "aria-label": props.title,
        title: props.title,
        className: classNames("progress-bar", {
            "progress-bar-striped": props.striped,
            "progress-bar-animated": props.animated,
        }),
        style: Object.assign(Object.assign({ width: props.progress * 100 + "%" }, (props.reverseAnimation ? { animationDirection: "reverse" } : {})), { backgroundColor: props.color || BootstrapColorService.Primary }),
    };
    if (props.link) {
        if (props.linkIsNotToReactPage) {
            return (
            // @ts-expect-error - TS2322 - Type '{ children: Element; role: "progressbar"; "aria-valuemin": "0"; "aria-valuemax": "100"; "aria-valuenow": number; "aria-label": string; title: string; className: string; style: { readonly backgroundColor: string; readonly animationDirection?: string | undefined; readonly width: string; }; href: string; }' is not assignable to type 'DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>'.
            _jsx("a", Object.assign({ href: props.link }, sharedProps, { children: _jsx("span", { className: "sr-only", children: props.title }) })));
        }
        return (
        // @ts-expect-error - TS2322 - Type '{ children: Element; role: "progressbar"; "aria-valuemin": "0"; "aria-valuemax": "100"; "aria-valuenow": number; "aria-label": string; title: string; className: string; style: { readonly backgroundColor: string; readonly animationDirection?: string | undefined; readonly width: string; }; to: string; }' is not assignable to type 'LinkProps<unknown>'.
        _jsx(Link, Object.assign({ to: "/" }, sharedProps, { children: _jsx("span", { className: "sr-only", children: props.title }) })));
    }
    // @ts-expect-error - TS2322 - Type '{ children: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; ... 7 more ...; style: { ...; }; }' is not assignable to type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.
    return _jsx("div", Object.assign({}, sharedProps, { children: props.label && props.label }));
};
const ProgressBar = (props) => {
    return (_jsx("div", { className: classNames("progress  flex-grow-1", {
            bordersBetweenBars: props.bordersBetweenBars,
        }), style: {
            height: props.height || DEFAULT_HEIGHT,
        }, children: props.bars.map((b, i) => (_createElement(Bar, Object.assign({}, b, { key: i, linkIsNotToReactPage: true })))) }));
};
export default ProgressBar;
